<div class="fleet-status" dir="rtl">
  <div class="app">

    <div class="header">
      <div class="head-right">
        <button class="back-btn" routerLink="/" title="بازگشت">
          <i class="fa fa-arrow-right"></i>
        </button>
        <div class="brand">
          <h1><i class="fa fa-truck"></i> داشبورد وضعیت ناوگان</h1>
          <small>FleetYar • پایش مدیریتی لحظه‌ای ناوگان</small>
        </div>
      </div>
      <div class="live">
        <span class="pulse"></span>
        <button class="btn-refresh" (click)="refresh()" title="بروزرسانی">
          <i class="fa fa-refresh" [class.fa-spin]="loading"></i> بروزرسانی
        </button>
      </div>
    </div>

    <div *ngIf="errorMsg" class="error">{{ errorMsg }}</div>

    <div *ngIf="loading" class="empty-box">
      <i class="fa fa-spinner fa-spin"></i>
      <span>در حال دریافت اطلاعات ناوگان...</span>
    </div>

    <div *ngIf="!loading && !fleetData.length && !errorMsg" class="empty-box">
      <i class="fa fa-truck"></i>
      <span>داده‌ای برای نمایش وجود ندارد</span>
    </div>

    <ng-container *ngIf="!loading && fleetData.length">

      <div class="kpis">
        <div class="card kpi" style="--accent:#36d7ff">
          <div class="label"><i class="fa fa-truck"></i> کل ناوگان</div>
          <div class="value">{{ kTotal }}</div>
        </div>
        <div class="card kpi" style="--accent:#4b8dff">
          <div class="label"><i class="fa fa-check-circle"></i> فعال در سامانه</div>
          <div class="value">{{ kActive }}</div>
        </div>
        <div class="card kpi" style="--accent:#8d73ff">
          <div class="label"><i class="fa fa-calendar"></i> فعال امروز</div>
          <div class="value">{{ kToday }}</div>
        </div>
        <div class="card kpi" style="--accent:#2bd486">
          <div class="label"><i class="fa fa-signal"></i> آنلاین</div>
          <div class="value">{{ kOnline }}</div>
        </div>
        <div class="card kpi" style="--accent:#ff5d6c">
          <div class="label"><i class="fa fa-exclamation-triangle"></i> قطع ارتباط</div>
          <div class="value">{{ kOffline }}</div>
        </div>
        <div class="card kpi" style="--accent:#718096">
          <div class="label"><i class="fa fa-question-circle"></i> بدون سابقه</div>
          <div class="value">{{ kNever }}</div>
        </div>
      </div>

      <div class="ops">
        <div class="card op">
          <div><span><i class="fa fa-car"></i> در حال حرکت</span></div>
          <b>{{ oMoving }}</b>
        </div>
        <div class="card op">
          <div><span><i class="fa fa-pause"></i> متوقف و آنلاین</span></div>
          <b>{{ oStopped }}</b>
        </div>
        <div class="card op">
          <div><span><i class="fa fa-key"></i> سوئیچ روشن / توقف</span></div>
          <b>{{ oIgnition }}</b>
        </div>
        <div class="card op">
          <div><span><i class="fa fa-crosshairs"></i> فاقد GPS</span></div>
          <b>{{ oNoGps }}</b>
        </div>
      </div>

      <div class="main">
        <div class="card section map-section">
          <div class="section-head">
            <div>
              <div class="section-title"><i class="fa fa-map"></i> پراکندگی لحظه‌ای ناوگان</div>
            </div>
            <div class="section-sub">{{ validMapCount }} موقعیت معتبر</div>
          </div>
          <div id="fleetMap"></div>
        </div>
        <div class="card section">
          <div class="section-head">
            <div>
              <div class="section-title"><i class="fa fa-heartbeat"></i> سلامت ارتباط ناوگان</div>
            </div>
          </div>
          <div class="chart-wrap"><canvas id="healthChart"></canvas></div>
          <div class="legend">
            <div class="legend-row" *ngFor="let r of healthData">
              <span><i class="dot" [style.background]="r.color"></i>{{ r.label }}</span>
              <b>{{ r.value }}</b>
            </div>
          </div>
        </div>
        <div class="card section">
          <div class="section-head">
            <div>
              <div class="section-title"><i class="fa fa-exclamation-triangle"></i> نیازمند توجه</div>
            </div>
          </div>
          <div class="attention">
            <div
              *ngFor="let a of attentionData"
              class="attention-item"
              (click)="setAttentionFilter(a.filter)">
              <span><i class="dot" [style.background]="a.color"></i>{{ a.title }}</span>
              <strong>{{ a.count }}</strong>
            </div>
          </div>
        </div>
      </div>

      <div class="card bottom-chart">
        <div class="section-head">
          <div>
              <div class="section-title"><i class="fa fa-bar-chart"></i> توزیع ناوگان براساس آخرین ارتباط</div>
          </div>
        </div>
        <div class="chart-wrap"><canvas id="ageChart"></canvas></div>
      </div>

      <div class="card table-card" id="fleetTableCard">
        <div class="section-head">
          <div>
              <div class="section-title"><i class="fa fa-table"></i> جزئیات ناوگان</div>
          </div>
        </div>
        <div class="toolbar">
          <input [(ngModel)]="searchText" (ngModelChange)="applyTableFilter()" placeholder="جستجو: پلاک، راننده، UnitID، گروه یا نوع وسیله">
          <select [(ngModel)]="statusFilter" (ngModelChange)="onStatusFilterChange()">
            <option *ngFor="let o of statusFilterOptions" [value]="o.value">{{ o.label }}</option>
          </select>
          <span class="count">{{ tableRows.length }} خودرو</span>
        </div>
        <div class="table-wrap">
          <table>
            <thead>
              <tr>
                <th>وضعیت</th><th>پلاک</th><th>نوع وسیله</th><th>راننده / عنوان</th>
                <th>UnitID</th><th>آخرین ارتباط</th><th>مدت عدم ارتباط</th><th>سرعت</th>
                <th>ACC</th><th>وضعیت دستگاه</th><th>GPS</th><th>گروه</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let r of tableRows">
                <td><span class="badge" [ngClass]="r.badgeCls">{{ r.badgeLbl }}</span></td>
                <td class="plate">{{ r.item.strVehicleNo || '-' }}</td>
                <td>{{ r.item.strMobileType_strComment || '-' }}</td>
                <td>{{ r.item.strFullName || '-' }}</td>
                <td dir="ltr">{{ r.item.strUnitID || '-' }}</td>
                <td>{{ r.lastUpd }}</td>
                <td>{{ r.age }}</td>
                <td>{{ r.item.iSpeed }}</td>
                <td [ngClass]="r.accOn ? 'acc-on' : 'acc-off'">{{ r.accOn ? 'روشن' : 'خاموش' }}</td>
                <td>{{ r.item.strDeviceStatus_strComment || '-' }}</td>
                <td>{{ r.gpsTxt }}</td>
                <td>{{ r.item.strMobileGroup_strComment || '-' }}</td>
              </tr>
              <tr *ngIf="!tableRows.length">
                <td colspan="12" class="empty-cell">خودرویی مطابق فیلتر یافت نشد</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </ng-container>

  </div>
</div>
